export const isObject = (a: unknown): a is Record<string, unknown> =>
  typeof a === 'object' && a != null;
